import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_RISK_AREA_OUTCOME_STATUS_LIST = "GET_RISK_AREA_OUTCOME_STATUS_LIST";

export const service = async () => {
  const options: object = {
    url: `/api/RiskAreaOutcome/GetRiskAreaOutcomeStatusAssociation/`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_RISK_AREA_OUTCOME_STATUS_LIST, service, mock);
